<template>
  <div class="category-menu-wrap">
    <div class="classMainBox">
      <div v-for="categoryTreeListItem  in categoryTreeListData" class="goodsClassMain">
        <div class="goodsCl">
          <div class="classImg">
            <img :src="categoryTreeListItem.icon_default" />
            <img :src="categoryTreeListItem.icon_change" />
          </div>
          <div class="classSpan">{{categoryTreeListItem.chinese_name}}</div>
        </div>
        <div style="width: 12px; background: transparent; height: 100%;"></div>
        <div class="classChildBox">
          <div class="classChild">
            <div v-for="categoryTreeListChildItem  in categoryTreeListItem.childs">
              <div class="className">{{categoryTreeListChildItem.chinese_name}}</div>
              <NuxtLink
                v-for="categoryTreeListLinkChildItem  in categoryTreeListChildItem.childs"
                :to="'/product/search?keyword='+categoryTreeListLinkChildItem.chinese_name"
              >{{categoryTreeListLinkChildItem.chinese_name}}</NuxtLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, watch } from "vue";  
import { useMainStore } from "~/composables/store";
import { Menu, Search, Camera } from "@element-plus/icons-vue";
import { useRoute } from "vue-router";
import { get } from "lodash-es";
import { categoryTreeListFn } from "./categoryConfig";
import { $t } from "~/utils/index.js";
const store = useMainStore();
const categoryTreeListData = computed(()=>{
    return categoryTreeListFn();
})
 
</script>

<style scoped lang="less">


.classMainBox {
  background-color: #fff;
  min-height: 615px;
  display: flex;
  height: 615px;
  flex-direction: column;
  border-radius: 6px;
  padding: 12px 0 12px 12px
}

.classMainBox .goodsClassMain {
  display: flex;
  flex: 1;
  cursor: pointer;
  background-color: #fff
}

.classMainBox .goodsClassMain .goodsCl {
  width: 100%;
  display: flex;
  padding-left: 20px;
  padding-right: 25px
}

.classMainBox .goodsClassMain .goodsCl .classImg {
  display: flex;
  justify-content: center;
  align-items: center
}

.classMainBox .goodsClassMain .goodsCl .classImg .icon {
  color: #fff
}

.classMainBox .goodsClassMain .goodsCl .classImg svg {
  width: 22px;
  height: 22px;
  margin-right: 15px
}

.classMainBox .goodsClassMain .goodsCl .classImg img {
  width: 20px;
  height: 20px;
  margin-right: 10px
}

.classMainBox .goodsClassMain .goodsCl .classImg img:last-child {
  display: none
}

.classMainBox .goodsClassMain .goodsCl .classSpan {
  display: flex;
  align-items: center;
  width: 100%
}

.classMainBox .goodsClassMain .goodsCl .classSpan span {
  font-size: 13px;
  font-weight: 500;
  line-height: 1.9em
}

.classMainBox .goodsClassMain .classChildBox {
  position: absolute;
  left: 100%;
  display: none;
  z-index: 3;
  top: -1px;
  overflow: hidden;
  height: 617px;
  padding-bottom: 50px
}

.classMainBox .goodsClassMain .classChildBox .shadowBlock {
  height: 100%
}

.classMainBox .goodsClassMain .classChildBox .classChild {
  padding: 0 0 20px 20px;
  margin-left: -20px;
  height: 620px;
  overflow-y: auto;
  display: flex;
  background-color: #fff
}

.classMainBox .goodsClassMain .classChildBox .classChild>div {
  max-height: 100%
}

.classMainBox .goodsClassMain .classChildBox .classChild::-webkit-scrollbar {
  width: 6px;
  height: 1px
}

.classMainBox .goodsClassMain .classChildBox .classChild::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,.2);
  background: silver
}

.classMainBox .goodsClassMain .classChildBox .classChild::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,.2);
  border-radius: 10px
}

.classMainBox .goodsClassMain .classChildBox .classChild .className {
  font-weight: 600;
  font-size: 14px;
  position: sticky;
  top: 0;
  padding-top: 20px;
  padding-left: 30px;
  padding-bottom: 10px;
  color: #b4272b;
  background-color: #fff;
  width: 100%
}

.classMainBox .goodsClassMain .classChildBox .classChild a {
  width: 210px;
  height: 34px;
  border-radius: 5px;
  text-overflow: -o-ellipsis-lastline;
  line-height: 14px;
  overflow: hidden;
  display: flex;
  align-items: center;
  font-size: 13px;
  font-weight: 500;
  padding-left: 30px;
  transition: .3s
}

.classMainBox .goodsClassMain .classChildBox .classChild a:hover {
  background-color: #faf2f2
}

.classMainBox .goodsClassMain:hover .goodsCl {
  box-shadow: 0 0 4px 0 rgba(0,0,0,.12);
  position: relative;
  z-index: 2;
  background-color: #b4272b;
  color: #fff
}

.classMainBox .goodsClassMain:hover .classChild {
  box-shadow: 0 0 4px 0 rgba(0,0,0,.12);
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  position: relative;
  left: 2px;
  z-index: 9
}

.classMainBox .goodsClassMain:hover .classImg img {
  width: 20px;
  height: 20px;
  margin-right: 10px;
  display: none
}

.classMainBox .goodsClassMain:hover .classImg img:last-child {
  display: block
}

.classMainBox .goodsClassMain:hover .classSpan span {
  color: #fff
}

.classMainBox .goodsClassMain:hover .classChildBox {
  display: block
}

</style>
